/**
 * This is used to help papaparse understand our stream.
 * It uses these fields for feature detection, but never actually calls read()
 * https://github.com/mholt/PapaParse/blob/master/papaparse.js#L244
 */

export default function makeZipStreamHelper(zipObj, onUpdate) {
  var helper = zipObj.internalStream('string');
  helper.readable = true;
  helper.read = () => false;
  helper.removeListener = () => false;
  helper.on('data', (_, metadata) => onUpdate(metadata));
  return helper;
}
//# sourceMappingURL=ZipStreamHelper.js.map